'use strict';

/* jshint esnext: true, loopfunc: true */

var checkType = require('./type');

var isNumber = checkType.isNumber;
var nativeMin = Math.min;
var nativeMax = Math.max;

var numberUtils = {
    isDecimal: function isDecimal(num) {
        return isNumber(num) && num % 1 !== 0;
    },
    isEven: function isEven(num) {
        return isNumber(num) && num % 2 === 0;
    },
    isFinite: isFinite,
    isInteger: Number.isInteger ? Number.isInteger : function (num) {
        return isNumber(num) && num % 1 === 0;
    },
    isNaN: isNaN,
    isNegative: function isNegative(num) {
        return isNumber(num) && num < 0;
    },
    isNumber: isNumber,
    isOdd: function isOdd(num) {
        return isNumber(num) && num % 2 !== 0;
    },
    isPositive: function isPositive(num) {
        return isNumber(num) && num > 0;
    },
    toFloat: function toFloat(str) {
        return parseFloat(str);
    },
    toInteger: function toInteger(str, radix) {
        return parseInt(str, radix || 10);
    },
    isInRange: function isInRange(value, start, end) {
        start = +start || 0;
        if (end === undefined) {
            end = start;
            start = 0;
        } else {
            end = +end || 0;
        }
        return value >= nativeMin(start, end) && value < nativeMax(start, end);
    }
};

numberUtils.isInFinite = function (num) {
    return !numberUtils.isFinite(num);
};

module.exports = numberUtils;


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-text/~/zero-lang/number.js
 ** module id = 38
 ** module chunks = 0
 **/